import { Injectable } from '@nestjs/common';
import { ExcelImportModel } from '@schemax-whatsapp/shared-models';
import { ExcelImport } from '../../entity/excel-import.entity';

@Injectable()
export class ExcelImportAdapter{

    public convertDtoToEntity(dto:ExcelImportModel):ExcelImport {
        const entity = new ExcelImport();
        entity.memberName = dto.memberName;
        entity.phoneNumber = dto.phoneNumber;
        entity.email = dto.email;
        return entity
    }

    public covertEntityToDto(obj:ExcelImport):ExcelImportModel {
        const dto = new ExcelImportModel(obj.memberName, obj.phoneNumber,obj.email, obj.excelImportId);
        return dto;
    }
}